import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { cloneDeep } from 'lodash';
import { useMemo } from 'react';

import { TSDViewConsignmentFormValues } from '@e-origin/contracts';
import { DocumentsEnum } from '@e-origin/shared';

import { Documents, TextInput } from '@components';
import { TSDDocumentFormSchema } from './TSDDocumentFormSchema';
import { TSDTransportEquipment } from './TSDTransportEquipment';

interface TSDViewTransferConsignmentProps {
  consignmentForm: UseFormReturnType<TSDViewConsignmentFormValues>;
  disabled: boolean;
}

export const TSDViewTransferConsignment: React.FC<TSDViewTransferConsignmentProps> = ({ consignmentForm, disabled }) => {
  const documentFormSchema = TSDDocumentFormSchema();

  const documents = useMemo(
    () => ({
      transportDocuments: [...(consignmentForm.values.master?.transportDocuments || [])],
    }),
    [consignmentForm.values.master?.transportDocuments],
  );

  const handleDocumentDelete = (documentType: DocumentsEnum, documentIndex: number) => {
    consignmentForm.setFieldValue(`master.${documentType}`, [...(consignmentForm.values.master[documentType] || []).filter((_, idx) => idx !== documentIndex)]);
  };

  const handleSavingDocument = (savedDocument: any) => {
    if (savedDocument.docIndex >= 0) {
      const updatedDocuments = consignmentForm.values.master[DocumentsEnum.TRANSPORT_DOCUMENTS].map((doc, idx) => {
        if (idx === savedDocument.docIndex) {
          return savedDocument.data;
        }
        return doc;
      });
      consignmentForm.setFieldValue(`master.${DocumentsEnum.TRANSPORT_DOCUMENTS}`, updatedDocuments);
    } else {
      const master = cloneDeep(consignmentForm.values.master || {});
      master[DocumentsEnum.TRANSPORT_DOCUMENTS] = [...(master[DocumentsEnum.TRANSPORT_DOCUMENTS] || []), savedDocument.data];
      consignmentForm.setFieldValue(`master`, master);
    }
  };

  return (
    <Stack>
      <Title order={5} fw={600}>
        Master consignment
      </Title>
      <Grid>
        <Grid.Col span={3}>
          <TextInput {...consignmentForm.getInputProps('master.totalGrossMass')} label="Total gross mass" disabled={disabled} />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput {...consignmentForm.getInputProps('master.totalNumberOfPackages')} label="Total number of packages" disabled={disabled} />
        </Grid.Col>
      </Grid>
      <Documents
        title="Transport documents"
        disabledDocuments={[
          DocumentsEnum.SUPPORTING_DOCUMENTS,
          DocumentsEnum.PREVIOUS_DOCUMENTS,
          DocumentsEnum.ADDITIONAL_INFORMATION,
          DocumentsEnum.ADDITIONAL_REFERENCE,
        ]}
        documents={documents}
        onDelete={handleDocumentDelete}
        onSave={handleSavingDocument}
        disabled={disabled}
        documentFormSchema={documentFormSchema}
      />
      <Stack>
        <Title order={5} fw={600}>
          Transport equipment
        </Title>

        <TSDTransportEquipment form={consignmentForm} disabled={disabled} transportEquipmentPath="master.transportEquipment" />
      </Stack>
    </Stack>
  );
};
